export default {
  drawLine: '连线',
  drawLineComponent: '连线组件',
  viewDrawLineArea: '查看起止区域',
  setDrawLineArea: '设置起止区域',
  onlyOneDrawLineTip: '同个场景内仅支持添加1个连线组件或1个自由画线组件。',
  addGroupWarning: '连线元件禁止打组',
  setDrawLine: '设置连线组件',
  drawLineEdit: {
    drawLineArea: '起止区域',
    addDrawLineArea: '添加起止区域',
    pairRelation: '配对关系',
    pairWay: '配对方式',
    pairCategory: '配对类别',
    addPairRelation: '添加配对关系',
    pairDefaultName: '配对',
    areaPlaceholder: '选择起止区域',
    noAreaTip: '请先添加起止区域',
    notAllowLineAgain: '连线成功后不允许再次连线',
    lineStyle: '线条样式',
    lineSizePlaceholder: '线条粗细',
    applyToOther: '应用到全部',
    preview: '预览所有连线线条',
    closePreview: '关闭预览',
    renameIsTooLongTip: '仅支持{len}个字符以内',
    renameIsEmptyTip: '名字不能为空',
    deletePairConfirmTip:
      '已有配对关系与游戏逻辑关联，删除后将无法恢复，确定删除吗？',
    deleteAreaConfirmTip:
      '已有起止区域与游戏逻辑关联，删除后将无法恢复，确定删除吗？',
    cancel: '取消',
    ok: '删除',
    category: {
      addCategory: '添加配对类别',
      enterCategoryPlaceholder: '请输入配对类别',
      nameDuplicateTip: '配对类别不可与已有类别重名。',
      nameRegTip: '仅支持英文、中文、数字、下划线，不能超过20个字符。',
      deleteComfirm: '删除后无法恢复，确认删除吗？',
      noData: '暂无数据',
      noDataTip: '点击按钮添加配对类别',
    },
    match: {
      isMatch: '是否匹配',
      placeholder: '选择匹配',
      match: '匹配',
      noMatch: '不匹配',
      pairPlaceholder: '选择配对关系',
      pairWayPlaceholder: '选择配对方式',
      pairCategoryPlaceholder: '选择配对类别',
    },
    lineDir: {
      title: '连线配对',
      singleDir: '单向',
      doubleDir: '双向',
    },
    lineType: {
      title: '连线类型',
      trajectoryLine: '自由绘制',
      straightLine: '直线',
    },
    splitText: '[起止区域位置及尺寸]横竖屏拆分',
    splitTip: '横屏和竖屏下，当前起止区域的位置和尺寸可分别设置为不同值。',
    vpEraseLineTip: '仅对直线生效，对自由绘制不生效',
    vpModifyLineStyleTip:
      '自由绘制：已画的线不生效，未画的线生效<br/>直线：已画和未画的线都生效',
    vpModifyPairLineStyle: '仅对直线生效，对自由绘制 不生效',
    pairTip: '已完成连线的起始区域无法再画线。',
    areaTip:
      '从该区域画出的线条的样式设置。<br/>需为该区域设置配对关系，才可画出线条。',
  },
  freeDrawLine: '自由画线',
  freeDrawLineComponent: '自由画线组件',
  setFreeDrawLine: '设置画线线条',
  setFreeDrawLineStyle: '线条样式',
  freeDrawLineEdit: {
    tab: '线条',
    preview: '预览线条',
    closePreview: '关闭预览',
    vpFreeEraseLineTip: '清除所有已画线条',
    vpFreeModifyLineStyleTip: '仅对未画的线生效，已画的不生效。',
  },
}
